import IconAmenityAirport from '@spothero/icons/amenity-airport';
import IconAmenityAttendant from '@spothero/icons/amenity-attendant';
import IconAmenityCoveredParking from '@spothero/icons/amenity-covered-parking';
import IconAmenityEv from '@spothero/icons/amenity-ev';
import IconAmenityImmediateParking from '@spothero/icons/amenity-immediate-parking';
import IconAmenityInOut from '@spothero/icons/amenity-in-out';
import IconAmenityMobile from '@spothero/icons/amenity-mobile';
import IconAmenityNoContract from '@spothero/icons/amenity-no-contract';
import IconAmenityPaved from '@spothero/icons/amenity-paved';
import IconAmenityPrinter from '@spothero/icons/amenity-printer';
import IconAmenitySelfPark from '@spothero/icons/amenity-self-park';
import IconAmenityShuttle from '@spothero/icons/amenity-shuttle';
import IconAmenityTailgating from '@spothero/icons/amenity-tailgating';
import IconAmenityTime247 from '@spothero/icons/amenity-time-247';
import IconAmenityValet from '@spothero/icons/amenity-valet';
import IconAmenityWheelchair from '@spothero/icons/amenity-wheelchair';

export default {
    airport: IconAmenityAirport,
    attendant: IconAmenityAttendant,
    'covered-parking': IconAmenityCoveredParking,
    ev: IconAmenityEv,
    'immediate-parking': IconAmenityImmediateParking,
    'in-out': IconAmenityInOut,
    mobile: IconAmenityMobile,
    'no-contract': IconAmenityNoContract,
    'one-tap': IconAmenityMobile,
    paved: IconAmenityPaved,
    printer: IconAmenityPrinter,
    'self-park': IconAmenitySelfPark,
    shuttle: IconAmenityShuttle,
    tailgating: IconAmenityTailgating,
    'time-24-7': IconAmenityTime247,
    valet: IconAmenityValet,
    wheelchair: IconAmenityWheelchair,
};
